export { MerchantLogoWithLogo, MerchantDefaultLogo, DefaultLogoWithoutLetter } from './CommonLogos';
